import { groupBy } from 'lodash'
import { useMemo } from 'react'

const useListGrouped = (list = [], key = 'id') => {
    const object = useMemo(() => groupBy(list, key), [list, key])
    return object
}

export default useListGrouped